// import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "md"
    },
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                // Generic theme overrides
                primary: "#e6e7e9",
                secondary: "#333333",
                // accent: '',
                // error: '',
                // info: '',
                // success: '',
                // warning: '',
                anchor: "#8c9eff",
                background: "#e6e7e9",
            },
            dark: {
                primary: "#e6e7e9",
                secondary: "#f16363",
                background: "#e6e7e9"
            }
        }
    }
});
